import { getStoredAuth } from '@app.raytd.com/store';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

declare global {
    interface Window {
        Pusher: typeof Pusher;
    }
}

window.Pusher = Pusher;

let echo: Echo<any> | null = null;

export const initializeEcho = () => {
  const auth = getStoredAuth();
  
  if (!auth?.token) {
    console.warn('Echo initialization failed: No auth token');
    return null;
  }

  const pusherKey = import.meta.env.VITE_PUSHER_APP_KEY;
  const pusherCluster = import.meta.env.VITE_PUSHER_APP_CLUSTER;
  const apiUrl = import.meta.env.VITE_API_URL;

  if (!pusherKey) {
    console.warn('Echo initialization failed: VITE_PUSHER_APP_KEY is not set');
    return null;
  }

  if (!pusherCluster) {
    console.warn('Echo initialization failed: VITE_PUSHER_APP_CLUSTER is not set');
    return null;
  }

  if (!apiUrl) {
    console.warn('Echo initialization failed: VITE_API_URL is not set');
    return null;
  }

  window.Pusher = Pusher;
  
  echo = new Echo({
    broadcaster: 'pusher',
    key: pusherKey,
    cluster: pusherCluster,
    forceTLS: true,
    authEndpoint: `${apiUrl}/broadcasting/auth`,
    auth: {
      headers: { Authorization: `Bearer ${auth.token}` },
    },
  });

  return echo;
};

export const getEcho = () => {
  if (!echo) {
    return initializeEcho();
  }
  return echo;
};